import React, { useState } from 'react';
import {
  Col,
  Collapse,
  Container,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Row,
} from 'reactstrap';

const App = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <Navbar color="inverse" light expand="md">
        <Container>
          <NavbarBrand href="/">
            <img src={'david_lloyd.jpg'} alt={'David Lloyd'} width={90} height={90} />
          </NavbarBrand>
          <div
            className="navbar-text mx-auto"
            style={{
              fontSize: '1.5rem',
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            David Lloyd
          </div>
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="mailto:lloy0076 [at] adam.com.au">E-Mail Me</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>

      <Container>
        <Row className={'justify-content-center'}>
          <Col className={'col-12'}>
            <img
              src={'jumbotron.jpg'}
              width={'100%'}
              alt={'David Lloyd (Country Side) Banner'}
            />
          </Col>
        </Row>

        <Row className={'justify-content-center'}>
          <Col className={'col-12 justify-content-center'}>
            <h1 style={{ textAlign: 'center' }}>
              About David
              <div className={'blockquote'}>
                <p className={'blockquote-footer'}>Per Veritatem Vis</p>
              </div>
            </h1>
            <hr />
          </Col>
        </Row>

        <Row className={'justify-content-center'}>
          <Col className={'col-12 col-md-5'} style={{ textAlign: 'justify' }}>
            <h3>Personal</h3>
            <p>
              David Lloyd lives with his wife, three cats and the cat "that is not ours but we've
              fed for the past six years" in Canton, New York. He dreams of building a straw bale
              house with his own hands. He'd like some chickens for freshly laid eggs each
              morning.
            </p>
            <p>
              He emigrated to the USA in 2016 and attends <a
              href={'https://www.gracechurchcanton.org/'}
              target={'_blank'}
            >Grace Episcopal Church</a> in Canton where he is the current webmaster, and serves
              on vestry. He is the current treasurer for <a
              href={'https://www.gracehousecantonny.org/'}
              target={'_blank'}
            >Grace House.</a>
            </p>

            <h3>Study</h3>
            <p>
              David holds a University Certificate in Theology from <a
              href={'https://stmarks.edu.au/'}
              target={'_blank'}
            >St. Mark's National Theological Centre</a>, and a Diploma in Spiritual Direction from&nbsp;
              <a
                href={'https://edod.org/our-diocese/stanton-institute-for-theology-and-practice/'}
                target={'_blank'}
              >Stanton Institute for Theology and Practice</a>.
            </p>
            <p>
              He is currently in the third year of a Master of Pastoral Ministry at <a
              href={'https://www.nashotah.edu/programs/hybrid-distance/master-of-pastoral-ministry/'}
              target={'_blank'}
            >Nashotah House</a> through Hybrid Distance Study. He is a Postulant to the Priesthood
              in the <a
              href={'https://albanyepiscopaldiocese.org/'}
              target={'_blank'}
            >Episcopal Diocese of Albany, NY</a>.
            </p>
          </Col>

          <Col className={'col-12 col-md-2'} style={{ textAlign: 'center' }}>
            <img
              src={'coa-white.jpg'}
              alt={'Per Veritatem Vis'}
              width={'100%'}
              className={'center-block'}
            />
          </Col>

          <Col className={'col-12 col-md-5'} style={{ textAlign: 'justify' }}>
            <h3>Professional</h3>
            <p>
              David is a remote backend API and web-developer located in Canton, New York. He has
              experience developing custom APIs in Python, PHP, Java, C#, JavaScript and other
              modern languages; he has integrated many third party APIs.
            </p>
            <p>
              In addition, David is an experienced system administrator, specialising in
              GNU/Linux, having experience
              with tools such as Ansible, Puppet and Vagrant. In his spare time, he likes to learn
              about the latest
              programming and web-development libraries and practices.
            </p>
            <p>
              His Github profile is <a
              href={'https://github.com/lloy0076'}
              target={'_blank'}
            >here</a>.
            </p>

            <h3>Publications</h3>
            <p>
              David has self-published one publication, "A Pastoral Handbook - Hurts, Hangups, and
              Addictions" which may be purchased directly from the <a
              href={'https://www.lulu.com/shop/david-lloyd/pastoral-handbook-addiction/paperback/product-v8y8dw8.html'}
              target={'_blank'}
            >Lulu bookstore</a>.
            </p>
          </Col>
        </Row>

        <Row className={'justify-content-center'}>
          <Col className={'col-12 justify-content-center'}>
            <hr />
            <span style={{ fontSize: 'xx-small' }}>Copyright &copy; 2026. David Lloyd.</span>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default App;
